import { config } from '../../config';
import type { Dispatch } from '../../types';
import { handleGeoBookedResponse } from '../services/BookingsService';
import { authenticatedGet } from './fetchActions';

export const fetchGeoBooked = () => (dispatch: Dispatch) => {
    const backend = config.backend.RIO_GEOFENCE_SHARED;
    const url = `${backend}/booked`;
    dispatch(fetchGeoBookedStarted());
    return dispatch(authenticatedGet(url))
        .then(json => {
            const geoBooked = handleGeoBookedResponse(json);
            dispatch(storeGeoBooked(geoBooked));
        })
        .catch(() => dispatch(fetchGeoBookedFailed()));
};

export const fetchGeoBookedStarted = () => ({
    type: 'FETCH_GEO_BOOKED_STARTED' as const,
});

export const fetchGeoBookedFailed = () => ({
    type: 'FETCH_GEO_BOOKED_FAILED' as const,
});

export const storeGeoBooked = (geoBooked: boolean) => ({
    type: 'STORE_GEO_BOOKED' as const,
    payload: geoBooked,
});
